'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIDialogBody;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function UIDialogBody(_ref) {
  var children = _ref.children,
      className = _ref.className;

  return _react2.default.createElement(
    'div',
    {
      className: (0, _reactUtils.classNames)('uiDialogBody', 'private-modal__body', 'has--vertical-spacing', className)
    },
    children
  );
}

UIDialogBody.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/dialog/UIDialogBody.js
// module id = 323
// module chunks = 0